// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"aa58db56b309fc50b2eb","883":"46dc8f3bd96db59235cd"}[chunkId] + ".js";
};